import React from "react";
import { NavLink } from "react-router-dom";
import "./styles.scss";
import { ReactComponent as Instagram } from "../../../../../public/icons/UserProfile/socialMedia/instagram.svg";
import { ReactComponent as Facebook } from "../../../../../public/icons/UserProfile/socialMedia/facebook.svg";
import { ReactComponent as Twitter } from "../../../../../public/icons/UserProfile/socialMedia/twitter.svg";
import { ReactComponent as Youtube } from "../../../../../public/icons/UserProfile/socialMedia/youtube.svg";
import { ReactComponent as Itunes } from "../../../../../public/icons/UserProfile/socialMedia/itunes.svg";
import { ReactComponent as Website } from "../../../../../public/icons/UserProfile/socialMedia/website.svg";
import { ReactComponent as Soundcloud } from "../../../../../public/icons/UserProfile/socialMedia/soundcloud.svg";
import { ReactComponent as Spotify } from "../../../../../public/icons/UserProfile/socialMedia/spotify.svg";
import { ReactComponent as Tiktok } from "../../../../../public/icons/UserProfile/socialMedia/tiktok.svg";
import { checkValidSocialMedia } from "../../../../../helper/helper";

export default ({ user }) => {
  const renderSocialMedia = () => {
    if (user && user.social_media_links) {
      const component = {
        instagram: Instagram,
        facebook: Facebook,
        twitter: Twitter,
        youtube: Youtube,
        itunes: Itunes,
        website: Website,
        soundcloud: Soundcloud,
        spotify: Spotify,
        tiktok: Tiktok,
      };
      return Object.keys(user.social_media_links)
        .filter((a) => component[a])
        .map((social, id) => {
          const SocialIcon = component[social];
          let url = user.social_media_links[social];
          const isValidSocialMedia = checkValidSocialMedia(social);
          if (url && !isValidSocialMedia && !url.startsWith("http://") && !url.startsWith("https://")) url = `https://${url}`;
          if (url && isValidSocialMedia) {
            url = url?.includes(`${social}.com`) ? url : `https://${social}.com/${url}`;
          }
          return url ? (
            <a key={id} href={url} target="blank" className="d-flex align-items-center justify-content-center">
              <SocialIcon className="mr-2" />
            </a>
          ) : (
            <></>
          );
        });
    }
    return <></>;
  };

  return (
    <div className="tabs d-flex position-relative" style={{ overflowX: "auto", minHeight: 40 }}>
      <div className="d-flex align-items-end">
        <NavLink className="tab" activeClassName="active" to={`/${user.slug}/`} exact>
          activity
          <div />
        </NavLink>
        {user.media.singles ? (
          user.user_type === "podcaster" ? null : (
            <NavLink className="tab" activeClassName="active" to={`/${user.slug}/singles`}>
              singles
              <div />
            </NavLink>
          )
        ) : null}
        {user.user_type === "podcaster" ? (
          <NavLink className="tab" activeClassName="active" to={`/${user.slug}/podcasts`}>
            Podcasts
            <div />
          </NavLink>
        ) : null}
        {user.media.albums ? (
          <NavLink className="tab" activeClassName="active" to={`/${user.slug}/albums`}>
            Albums
            <div />
          </NavLink>
        ) : null}
        <NavLink className="tab" activeClassName="active" to={`/${user.slug}/playlists`}>
          playlists
          <div />
        </NavLink>

        {user.user_type === "artist" || user.user_type === "podcaster" ? (
          <NavLink
            // target="_blank"
            className="tab"
            activeClassName="active"
            to={`/${user.slug}/about`}
            exact
          >
            About
            <div />
          </NavLink>
        ) : null}
      </div>
      <div className="social-media d-flex flex-grow-1 justify-content-end align-items-center pr-3">
        <div className="d-flex">{renderSocialMedia()}</div>
      </div>
    </div>
  );
};
